import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Heading from './components/Heading';
import Footer from './components/Footer';
//import Summary from './components/Summary';
//import SummaryError from './components/SummaryError';
//import AccordionFrame from './components/AccordionFrame';
import Information from './components/Information';
import Message from "./components/Message";
//import Timeout from "./components/Timeout";
import Loader from "./components/Loader";
import LogoutInfo from "./components/LogoutInfo";
import 'whatwg-fetch'; // IE fetch support
import Promise from 'promise-polyfill';
import * as utils from "./utils";
// To add to window
if (!window.Promise) {
    window.Promise = Promise;
}


function loginIDporten() {
    var vars = [], hash;
    var q = document.URL.split('?')[1];
    if(q !== undefined) {
        q = q.split('&');
        for (var i = 0; i < q.length; i++) {
            hash = q[i].split('=');
            vars.push(hash[1]);
            vars[hash[0]] = hash[1];
        }
    }

    if (vars['err'] === '401' || vars['err'] === '503') {
        ReactDOM.render(<App/>, document.getElementById('root'));
        ReactDOM.render(<Heading text=""/>, document.getElementById('heading'));
        ReactDOM.render(<Message error='Tjenesten er ikke tilgjengelig for øyeblikket, prøv igjen senere' type={'errorMessage'}/>, document.getElementById('message'));
        ReactDOM.render(<Information/>, document.getElementById('information'));
        ReactDOM.render(<Footer/>, document.getElementById('footer'));
        window.history.replaceState({}, document.title, "/innsyn");
    }
    else if (vars['err'] === 'login') {
        ReactDOM.render(<App/>, document.getElementById('root'));
        ReactDOM.render(<Heading text=""/>, document.getElementById('heading'));
        ReactDOM.render(<Message error='Problemer med innlogging, prøv igjen senere' type={'errorMessage'}/>, document.getElementById('message'));
        ReactDOM.render(<Information/>, document.getElementById('information'));
        ReactDOM.render(<Footer/>, document.getElementById('footer'));
        window.history.replaceState({}, document.title, "/innsyn");
    }
    else {
        window.location.replace(window.location.href + "login");
    }

}


// getDataFromLocalBackend


function loadData() {
    var heading = '';
    ReactDOM.render(<Heading text={heading}/>, document.getElementById('heading'));
    ReactDOM.render(<LogoutInfo show={true}/>, document.getElementById('logoutinfo'));
    utils.getDataFromLocalBackend();
}


function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


var client = new XMLHttpRequest();
client.open("GET", document.location, true);
client.send();
client.onreadystatechange = function () {
    if (this.readyState === this.HEADERS_RECEIVED) {
        var cookie = getCookie("INNSYN_CLIENT");
        if (null !== cookie && cookie !== "") {
            ReactDOM.render(<App/>, document.getElementById('root'));
            ReactDOM.render(<Heading text=""/>, document.getElementById('heading'));
            ReactDOM.render(<Footer/>, document.getElementById('footer'));
            ReactDOM.render(<Loader show={true}/>, document.getElementById('Loader'));
            window.history.replaceState({}, document.title, "/innsyn");
            loadData();
        }
        else {
            loginIDporten();
        }
    }
}


